import React from 'react';
import { Link } from 'react-router-dom';
import StandardLayout from '../../components/layout/StandardLayout';
import {
    PlusCircleIcon,
    ListBulletIcon,
    FolderPlusIcon,
    DocumentPlusIcon,
    DocumentDuplicateIcon,
    ArrowsRightLeftIcon,
    FolderIcon,
    DocumentIcon,
    Square2StackIcon,
    BookOpenIcon,
    PlusIcon
} from '@heroicons/react/24/outline';
import Alert from '../../components/Alert';

const AdminPage = () => {
    const adminSections = [
        {
            title: "Fragen Management",
            items: [
                {
                    title: 'Fragen hinzufügen',
                    path: '/admin/questions/add',
                    icon: PlusCircleIcon,
                    description: 'Neue Fragen zur Datenbank hinzufügen'
                },
                {
                    title: 'Fragen Übersicht',
                    path: '/admin/questions',
                    icon: ListBulletIcon,
                    description: 'Alle Fragen anzeigen und bearbeiten'
                }
            ]
        },
        {
            title: "Kategorien Management",
            items: [
                {
                    title: 'Neue Kategorie',
                    path: '/admin/categories/add',
                    icon: FolderPlusIcon,
                    description: 'Neue Fragenkategorie erstellen'
                },
                {
                    title: 'Kategorien Übersicht',
                    path: '/admin/categories',
                    icon: FolderIcon,
                    description: 'Alle Kategorien anzeigen und bearbeiten'
                }
            ]
        },
        {
            title: "Micro-Learning Management",
            items: [
                {
                    title: 'Neuer Katalog',
                    path: '/admin/catalogs/add',
                    icon: PlusIcon,
                    description: 'Neuen Lernkatalog erstellen'
                },
                {
                    title: 'Kataloge Übersicht',
                    path: '/admin/catalogs',
                    icon: BookOpenIcon,
                    description: 'Alle Lernkataloge anzeigen und bearbeiten'
                }
            ]
        },
        {
            title: "Prüfungen Management",
            items: [
                {
                    title: 'Neue Prüfung',
                    path: '/admin/exams/add',
                    icon: DocumentPlusIcon,
                    description: 'Neuen Prüfungsbogen erstellen'
                },
                {
                    title: 'Neuer Prüfungsteil',
                    path: '/admin/exam-parts/add',
                    icon: DocumentDuplicateIcon,
                    description: 'Neuen Prüfungsteil erstellen'
                },
                {
                    title: 'Prüfungen Übersicht',
                    path: '/admin/exams',
                    icon: DocumentIcon,
                    description: 'Alle Prüfungsbögen anzeigen und bearbeiten'
                },
                {
                    title: 'Prüfungsteile Übersicht',
                    path: '/admin/exam-parts',
                    icon: Square2StackIcon,
                    description: 'Prüfungsteile verwalten'
                }
            ]
        },
        {
            title: "Zuordnungen",
            items: [
                {
                    title: 'Frage - Katalog Zuordnung',
                    path: '/admin/mapping/catalog',
                    icon: ArrowsRightLeftIcon,
                    description: 'Fragen zu Lernkatalogen zuordnen'
                },
                {
                    title: 'Frage - Prüfung Zuordnung',
                    path: '/admin/mapping/exam',
                    icon: ArrowsRightLeftIcon,
                    description: 'Fragen zu Prüfungsteilen zuordnen'
                }
            ]
        }
    ];

    return (
        <StandardLayout>
            <div className="container mx-auto px-4 py-8">
                <Alert />
                <div className="mb-8">
                    <h1 className="text-2xl font-bold mb-2">Admin Dashboard</h1>
                    <p className="text-base-content/70">Verwaltung der Fragen und Prüfungsbögen</p>
                </div>

                <div className="space-y-8">
                    {adminSections.map((section, index) => (
                        <div key={index} className="space-y-4">
                            <h2 className="text-xl font-semibold border-b pb-2">{section.title}</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {section.items.map((item) => (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        className="card bg-base-100 hover:bg-base-300 border transition-colors duration-200 shadow-lg"
                                    >
                                        <div className="card-body flex flex-row items-center gap-4">
                                            <item.icon className="w-8 h-8 text-primary shrink-0" />
                                            <div>
                                                <h2 className="card-title">{item.title}</h2>
                                                <p className="text-sm text-base-content/70">{item.description}</p>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </StandardLayout>
    );
};

export default AdminPage; 